import React, { useState } from 'react';
import { 
  LayoutDashboard, PieChart as PieChartIcon, Compass, Users, List, HelpCircle, Sparkles, FolderOpen,
  QrCode, CheckSquare, Settings, Star, Activity, BookOpen, X, LogOut, MessageSquare,
  Bug, Lightbulb, HeartPulse, Send, Loader2, CheckCircle2, CalendarDays
} from 'lucide-react';
// YENİ: Firebase kayıt işlemi için (Yolunu projene göre kontrol et)
import { db, saveToCloud } from '../firebase'; 

// --- YENİ BİLEŞEN: GERİ BİLDİRİM MODALI ---
const FeedbackModal = ({ isOpen, onClose, user }) => {
  const [step, setStep] = useState('select'); // 'select', 'write', 'success'
  const [category, setCategory] = useState(null); // 'bug', 'feature', 'testimonial'
  const [message, setMessage] = useState('');
  const [consent, setConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const categories = [
    { id: 'bug', icon: Bug, title: 'Hata Bildirimi', desc: 'Sistemde karşılaştığınız teknik bir sorunu iletin.', color: 'text-rose-500', bg: 'bg-rose-50', border: 'border-rose-100' },
    { id: 'feature', icon: Lightbulb, title: 'Geliştirme Fikri', desc: 'Şu özellik veya envanter de eklense harika olur!', color: 'text-amber-500', bg: 'bg-amber-50', border: 'border-amber-100' },
    { id: 'testimonial', icon: HeartPulse, title: 'Deneyimini Paylaş', desc: 'Rehber360 mesleki hayatınızı nasıl kolaylaştırdı?', color: 'text-emerald-500', bg: 'bg-emerald-50', border: 'border-emerald-100' }
  ];

  const handleSubmit = async () => {
    if (message.trim().length < 10) return alert("Lütfen en az 10 karakterlik bir açıklama yazınız.");
    
    setIsSubmitting(true);
    try {
      const feedbackData = {
        category,
        message,
        consentForPublic: category === 'testimonial' ? consent : false,
        userName: user?.fullName || 'Bilinmiyor',
        userSchool: user?.schoolName || 'Bilinmiyor',
        userCode: user?.refCode || '',
        userUid: user?.uid || '',
        createdAt: new Date().toISOString(),
        status: 'new' // Admin paneli için
      };

      // Firebase'e 'feedbacks' koleksiyonu altına kaydet
      await saveToCloud('feedbacks', feedbackData);
      setStep('success');
    } catch (error) {
      alert("Gönderim başarısız oldu. Lütfen internet bağlantınızı kontrol edin.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetAndClose = () => {
    setTimeout(() => {
      setStep('select');
      setCategory(null);
      setMessage('');
      setConsent(false);
    }, 300);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden relative text-slate-800 animate-in zoom-in-95 duration-300">
        
        {/* Üst Kısım */}
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
          <div>
            <h2 className="text-xl font-black text-slate-800">Geri Bildirim & Destek</h2>
            <p className="text-xs font-medium text-slate-500 mt-1">Sesiniz rotamızı belirliyor.</p>
          </div>
          <button onClick={resetAndClose} className="p-2 bg-white hover:bg-slate-100 text-slate-400 rounded-full border border-slate-200 transition-colors">
            <X className="h-5 w-5"/>
          </button>
        </div>

        {/* Gövde */}
        <div className="p-6">
          
          {step === 'select' && (
            <div className="space-y-3">
              <p className="text-sm font-bold text-slate-700 mb-4">Lütfen iletmek istediğiniz konunun türünü seçin:</p>
              {categories.map((cat) => (
                <button 
                  key={cat.id} 
                  onClick={() => { setCategory(cat.id); setStep('write'); }}
                  className={`w-full text-left p-4 rounded-2xl border transition-all duration-200 flex items-start gap-4 hover:shadow-md group ${cat.bg} ${cat.border} hover:border-${cat.color.split('-')[1]}-300`}
                >
                  <div className={`p-3 rounded-xl bg-white shadow-sm ${cat.color} shrink-0`}>
                    <cat.icon className="h-6 w-6"/>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-800 text-base">{cat.title}</h3>
                    <p className="text-xs text-slate-500 mt-1 leading-relaxed">{cat.desc}</p>
                  </div>
                </button>
              ))}
            </div>
          )}

          {step === 'write' && (
            <div className="animate-in slide-in-from-right-4 duration-300">
              <button onClick={() => setStep('select')} className="text-xs font-bold text-blue-600 mb-4 hover:underline">&larr; Kategori Seçimine Dön</button>
              
              <textarea 
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Düşüncelerinizi buraya yazabilirsiniz..."
                className="w-full h-32 p-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm focus:ring-2 focus:ring-blue-500 focus:bg-white outline-none transition-colors resize-none mb-4"
              />

              {category === 'testimonial' && (
                <label className="flex items-start gap-3 p-4 bg-blue-50 border border-blue-100 rounded-xl cursor-pointer mb-6">
                  <input 
                    type="checkbox" 
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    className="mt-1 w-4 h-4 text-blue-600 rounded border-slate-300 focus:ring-blue-500"
                  />
                  <span className="text-xs text-blue-900 font-medium leading-relaxed">
                    Bu yorumumun, okulumun türü ve ismimin baş harfleriyle (Örn: S.A. - Meslek Lisesi) birlikte Rehber360 anasayfasında diğer meslektaşlarıma ilham olması için yayınlanmasına izin veriyorum.
                  </span>
                </label>
              )}

              <button 
                disabled={isSubmitting}
                onClick={handleSubmit} 
                className="w-full py-4 bg-slate-900 text-white rounded-xl font-bold flex items-center justify-center hover:bg-slate-800 transition disabled:opacity-50 shadow-lg"
              >
                {isSubmitting ? <Loader2 className="h-5 w-5 animate-spin"/> : <Send className="h-4 w-4 mr-2"/>}
                {isSubmitting ? 'Gönderiliyor...' : 'Geri Bildirimi Gönder'}
              </button>
            </div>
          )}

          {step === 'success' && (
            <div className="text-center py-8 animate-in zoom-in duration-300">
              <div className="h-20 w-20 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 className="h-10 w-10"/>
              </div>
              <h3 className="text-xl font-black text-slate-800 mb-2">Teşekkür Ederiz!</h3>
              <p className="text-sm text-slate-500 px-4">Geri bildiriminiz başarıyla iletildi. Rehber360'ı birlikte geliştirmeye devam edeceğiz.</p>
              <button onClick={resetAndClose} className="mt-8 px-6 py-2.5 bg-slate-100 text-slate-600 font-bold text-sm rounded-xl hover:bg-slate-200 transition">Kapat</button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};
// ------------------------------------------------

const Sidebar = ({
  currentView,
  setView,
  onLogout,
  user,
  isOpen,
  onClose,
    academicYear,
  activeAcademicYear,
  academicYears = [],
  onAcademicYearChange
}) => {
 
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false); // YENİ: Modal State'i

  const menuItems = user.role === 'specialist' ? [ 
    { id: 'dashboard', label: 'Genel Bakış', icon: LayoutDashboard }, 
    { id: 'class-analysis', label: 'Kurumsal Analiz', icon: PieChartIcon }, 
    { id: 'class-manager', label: 'Sınıf Yönetimi', icon: Users },
    { id: 'planning-center', label: 'Planlama Merkezi', icon: CalendarDays },
    { id: 'students', label: 'Gelen Kutusu', icon: List }, 
    { id: 'student-folders', label: 'Öğrenci Klasörleri', icon: FolderOpen },
    { id: 'tests', label: 'Envanterler & QR', icon: QrCode }, 
    { id: 'career-compass', label: 'Tercih ve Kariyer', icon: Compass },
    { id: 'coaching', label: 'Koçluk & Plan', icon: CheckSquare },
    { id: 'ai-workshop', label: 'AI İçerik Atölyesi', icon: Sparkles },
    { id: 'materials', label: 'Doküman Çantası', icon: FolderOpen }, 
    { id: 'guide', label: 'Nasıl Kullanılır?', icon: HelpCircle },
    { id: 'settings', label: 'Ayarlar', icon: Settings },
    ...(user.uid === 'J8Pu0gQodCNZoKPodmBRPJVxVyw2' ? [{ id: 'admin-panel', label: 'Süper Admin', icon: Star }] : [])
  ] : [
    { id: 'student-dashboard', label: 'Ana Sayfa', icon: LayoutDashboard }, 
    { id: 'student-planner', label: 'Haftalık Programım', icon: CheckSquare }, 
    { id: 'student-tests', label: 'Envanterlerim', icon: Activity }, 
    { id: 'student-knowledge', label: 'Bilgi Köşesi', icon: BookOpen } 
  ]; 
  
 return ( 
    <> 
      {isOpen && (<div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={onClose}></div>)} 
      <div className={`fixed top-0 left-0 h-screen w-64 bg-slate-900 text-white flex flex-col shadow-2xl z-50 transition-transform duration-300 ease-in-out md:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}> 
        
        {/* Üst Kısım */}
        <div className="p-6 border-b border-slate-800 flex justify-between items-center shrink-0"> 
          <div>
            <h1 className="text-xl font-black tracking-tight">Rehber<span className="text-blue-500">360</span></h1>
            {user.role === 'specialist' && (
                <div className="mt-1.5">
                    <p className="text-xs font-bold text-white truncate max-w-[160px]">{user.fullName}</p>
                    <p className="text-[9px] text-slate-400 truncate max-w-[160px]">{user.schoolName}</p>
                    <span className={`inline-block mt-1.5 px-2 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider ${user.isPremium ? 'bg-amber-500 text-black' : 'bg-slate-700 text-slate-300'}`}>{user.isPremium ? 'PREMIUM UZMAN' : 'FREE PLAN'}</span>
                <div className="mt-3">
  <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mb-1.5">
    Eğitim Öğretim Yılı
  </p>

  <select
    value={academicYear}
    onChange={(e) => onAcademicYearChange?.(e.target.value)}
    className="w-full bg-slate-800 border border-slate-700 text-white text-[11px] font-bold rounded-lg px-2.5 py-2 outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
  >
    {academicYears.map(year => (
      <option key={year} value={year}>
        {year === activeAcademicYear
          ? `${year} • Aktif`
          : `${year} • Geçmiş`
        }
      </option>
    ))}
  </select>

  {academicYear !== activeAcademicYear && (
    <div className="mt-2 px-2 py-1.5 rounded-lg bg-amber-500/10 border border-amber-500/20">
      <p className="text-[9px] font-bold text-amber-300">
        Geçmiş dönem görüntüleniyor
      </p>
    </div>
  )}
</div>
                </div>
            )}
            {user.role === 'student' && <p className="text-[10px] text-slate-500 mt-1 uppercase tracking-widest">Öğrenci Paneli</p>}
          </div> 
          <button onClick={onClose} className="md:hidden p-2 text-slate-400 hover:text-white"><X className="h-5 w-5"/></button> 
        </div> 

        {/* Menü İtemleri */}
        <div className="flex-1 py-4 px-3 space-y-1 overflow-y-auto flex flex-col [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-700/50 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-slate-500 transition-all">
        {menuItems.map(item => (
  <button
    key={item.id}
    onClick={() => {
      setView(item.id);
      onClose();
    }}
    className={`w-full flex items-center p-2.5 rounded-xl transition-all duration-200 shrink-0 ${
      currentView === item.id
        ? 'bg-blue-600 text-white shadow-md'
        : 'text-slate-400 hover:bg-slate-800 hover:text-white'
    }`}
  >
    <item.icon className="h-4 w-4 mr-3" />
    <span className="font-bold text-xs">
      {item.label}
    </span>
  </button>
))}
        </div> 

        {/* Premium Kutusu */}
        {user.role === 'specialist' && !user.isPremium && (
          <div className="px-3 pb-3 shrink-0 pt-2 border-t border-slate-800/50">
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 p-3 rounded-xl flex items-center justify-between shadow-lg">
              <div>
                <div className="flex items-center text-amber-500 mb-0.5"><Star className="h-3 w-3 mr-1.5 fill-current"/><span className="font-bold text-[10px] tracking-wider">PREMIUM</span></div>
                <p className="text-[9px] text-slate-400">Sınırsız Analiz</p>
              </div>
              <button onClick={() => setView('pricing')} className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-[10px] font-bold transition shadow-sm">
                Yükselt
              </button>
            </div>
          </div>
        )} 

        {/* 🎯 YENİ: Geri Bildirim Butonu */}
        {user.role === 'specialist' && (
          <div className="px-3 pb-3 shrink-0">
            <button onClick={() => setIsFeedbackOpen(true)} className="w-full flex items-center justify-center p-2.5 bg-indigo-500/10 hover:bg-indigo-500/20 text-indigo-300 hover:text-indigo-200 border border-indigo-500/20 rounded-xl transition font-bold text-xs">
              <MessageSquare className="h-4 w-4 mr-2"/> Geri Bildirim & Fikir
            </button>
          </div>
        )}

        {/* Çıkış Butonu */}
        <div className="p-3 border-t border-slate-800 shrink-0">
          <button onClick={onLogout} className="w-full flex items-center justify-center p-2.5 text-rose-400 hover:bg-rose-900/20 rounded-xl transition font-bold text-xs"><LogOut className="h-4 w-4 mr-2"/> Çıkış Yap</button>
        </div> 

      </div> 

      {/* YENİ MODAL ÇAĞRISI */}
      <FeedbackModal isOpen={isFeedbackOpen} onClose={() => setIsFeedbackOpen(false)} user={user} />
    </> 
  );
};

export default Sidebar;